// // src/PrivateRoute.js
// import React from "react";
// import { Navigate } from "react-router-dom";

// export default function PrivateRoute({ children }) {
//   const isLoggedIn = localStorage.getItem("isLoggedIn");

//   // ❌ Not logged in → go to login
//   if (!isLoggedIn) {
//     return <Navigate to="/login" />;
//   }

//   // ✅ Logged in → allow access
//   return children;
// }

import React from "react";
import { Navigate } from "react-router-dom";

export default function PrivateRoute({ children }) {
  const isLoggedIn = localStorage.getItem("isLoggedIn") === "true";

  return isLoggedIn ? children : <Navigate to="/gruhlaxmiMyAdmin/login" />;
}
